var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubtractionBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1400,
    height: 427.145,
    viewBox: "0 0 1400 427.145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_11",
    "data-name": "Subtraction 11",
    d: "M746.26,1466.145c-18.884,0-37.955-.676-56.684-2.01-18.543-1.319-37.248-3.317-55.6-5.938-18.163-2.595-36.457-5.869-54.374-9.732-17.758-3.829-35.594-8.333-53.014-13.387A789.163,789.163,0,0,1,46.26,1039h1400a788.025,788.025,0,0,1-480.332,396.077c-17.427,5.055-35.263,9.559-53.014,13.387-17.916,3.863-36.21,7.137-54.374,9.732-18.349,2.621-37.054,4.619-55.6,5.938C784.214,1465.469,765.143,1466.145,746.26,1466.145Z",
    transform: "translate(1446.26 1466.145) rotate(180)",
    fill: "#d62828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtractionBg);
export default __webpack_public_path__ + "static/media/Subtraction-bg.a124fbf429dd244eb84171a44a4e4efb.svg";
export { ForwardRef as ReactComponent };